export default __webpack_public_path__ + "static/media/member_card_v3_penuh.627abba6.png";